import React, { PropsWithChildren } from 'react'

const SUB_HEADING_STYLES =
  'text-h3 font-body font-normal text-xl mt-4 mr-0 mb-3 ml-0'

export const SubHeading: React.FC<PropsWithChildren> = ({ children }) => (
  <h2 className={SUB_HEADING_STYLES}>{children}</h2>
)

SubHeading.displayName = 'Content.SubHeading'
